import {appendAmplitudeCrossDomainParams, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {useMatchedSite} from "../../km_app/hooks/use_matched_site";
import {rpRedirectUrl} from "../../km_app/utils/read_environment_variables";
import {setRedirectPath} from "../state/auth_slice";
import {clearRedirectPath, readRedirectPath} from "../utils/redirect_path_storage";
import {resolveAuthRedirectPath} from "../utils/resolve_auth_redirect_path";

const rpHostname = rpRedirectUrl ? new URL(rpRedirectUrl).hostname : "";

export const useAfterAuthRedirect = () => {
    const site = useMatchedSite();
    const dispatch = useAppDispatch();
    const redirectPath = useAppSelector((state) => state.auth.redirectPath);

    return async () => {
        const targetUrl = resolveAuthRedirectPath(redirectPath ?? readRedirectPath(), site);

        dispatch(setRedirectPath(null));
        clearRedirectPath();
        await waitForAmplitudeInitialization();
        window.location.href = appendAmplitudeCrossDomainParams(targetUrl, [rpHostname]);
    };
};
import {appendAmplitudeCrossDomainParams, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {useMatchedSite} from "../../km_app/hooks/use_matched_site";
import {rpRedirectUrl} from "../../km_app/utils/read_environment_variables";
import {setRedirectPath} from "../state/auth_slice";
import {clearRedirectPath, readRedirectPath} from "../utils/redirect_path_storage";
import {resolveAuthRedirectPath} from "../utils/resolve_auth_redirect_path";

const rpHostname = rpRedirectUrl ? new URL(rpRedirectUrl).hostname : "";

export const useAfterAuthRedirect = () => {
    const site = useMatchedSite();
    const dispatch = useAppDispatch();
    const redirectPath = useAppSelector((state) => state.auth.redirectPath);

    return async () => {
        const targetUrl = resolveAuthRedirectPath(redirectPath ?? readRedirectPath(), site);

        dispatch(setRedirectPath(null));
        clearRedirectPath();
        await waitForAmplitudeInitialization();
        window.location.href = appendAmplitudeCrossDomainParams(targetUrl, [rpHostname]);
    };
};
